import { useEffect, useState, useCallback } from "react";
import { Loader2, Compass } from "lucide-react";
import { api } from "@/lib/api";
import { OVERLINE, H1, useAdmin } from "@/components/admin/ui";
import { BusinessTable, BusinessDrawer } from "@/pages/admin/AdminBusinesses";

export default function AdminGuides() {
  const { admin } = useAdmin();
  const [rows, setRows] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = useCallback(() => { api.adminGuides().then((d) => setRows(d.guides)).catch(() => setRows([])); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 md:p-8" data-testid="admin-guides">
      <span className={OVERLINE}>Network</span>
      <h1 className={`${H1} mt-1`}>Guides &amp; Outfitters</h1>
      <p className="text-sm text-[#5C6B61] mt-2">Verify guides and outfitters before they display a verification badge.</p>
      {rows === null ? <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-[#1F2A22]" /></div>
        : rows.length === 0 ? <div className="mt-8 border border-dashed border-[#E5E2DC] bg-white p-16 text-center text-[#5C6B61]"><Compass size={28} className="mx-auto mb-2 text-[#E5E2DC]" />No guides or outfitters yet.</div>
        : <BusinessTable rows={rows} onOpen={setOpenId} />}
      <p className="text-sm text-[#5C6B61] mt-3">{rows?.length || 0} guides &amp; outfitters</p>
      {openId && <BusinessDrawer id={openId} onClose={() => setOpenId(null)} onChanged={load} canManage={admin?.permissions?.includes("guides")} />}
    </div>
  );
}
